// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2024 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//
import { fontConfig } from "@conklin/XDL/PreStyle/typography";
import { cartFulfillmentMethodStyles } from "@insite/content-library/Widgets/Cart/CartFulfillmentMethodSelector";
import { css } from "styled-components";

cartFulfillmentMethodStyles.pickUpLocation = {
    wrapper: {
        css: css`
            margin-top: 10px;
        `,
    },
    headerText: {
        variant: "h6",
        css: css`
            display: inline-block;
            margin: 0;
        `,
    },
    changeLink: {
        typographyProps: {
            size: fontConfig.fontSize.small,
            lineHeight: fontConfig.lineHeight.small,
            weight: fontConfig.weight.bold,
        },

        css: css`
            margin-left: 24px;
            align-items: end;
        `,
    },
    warehouseAddress: {
        nameText: {
            as: "p",
            variant: "h6",
            weight: fontConfig.weight.regular,
            css: css`
                margin: 0;
            `,
        },
    },
};
cartFulfillmentMethodStyles.fulfillmentMethodRadio = {
    mergeCss: true,
    css: css`
        display: inline-flex;
    `,
};
